module.exports = __webpack_public_path__ + "static/media/eraser.7c672f39.svg";